import React, { createContext, useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db, auth } from '../firebaseConfig'; // Firebase config

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            if (user) {
                const userRef = doc(db, 'users', user.uid);
                // Utilisation de onSnapshot pour synchroniser en temps réel
                const unsubscribeSnapshot = onSnapshot(userRef, docSnap => {
                    if (docSnap.exists()) {
                        setUserData(docSnap.data());
                    }
                    setLoading(false);
                });

                return () => unsubscribeSnapshot(); // Arrête d'écouter lorsque le composant se démonte
            } else {
                setUserData(null);
                setLoading(false);
            }
        });

        return () => unsubscribe(); // Se désinscrire de l'écoute de l'authentification
    }, []);

    return (
        <UserContext.Provider value={{ userData, setUserData }}>
            {!loading && children}
        </UserContext.Provider>
    );
};
